export enum SyncIcon {
  syncAll = "sync-all",
  xCircle = "x-circle",
  checkCircle = "check-circle",
  alertTriangle = "alert-triangle",
}
